import cx from "classnames";
import React from "react";

import { SellerEntity } from "@/mk2/apps/bazaar/schemas";
import {
    bazaarSellerBazaarUrl,
    bazaarSellerReviewsFromBuyersUrl,
    bazaarSellerReviewsFromSellersUrl,
} from "@/mk2/apps/bazaar/urls";
import { LineMenu } from "@/mk2/components/LineMenu";
import { Link } from "@/mk2/components/Link";
import { url } from "@/mk2/helpers/urls";
import { RoutePathPattern } from "@/mk2/services/browserHistory";
import { BZ2_MENU_PRODUCTS, BZ2_MENU_REVIEWS } from "@/mk/autogenerated/translations/SellerLineMenu.9709f16861879152080343a637f6799a";

import styles from "./SellerLineMenu.mscss";

interface OwnProps {
    className?: string;
    seller: SellerEntity;
    routePathPattern: RoutePathPattern;
}

type Props = OwnProps;

const SellerLineMenu = React.memo<Props>(({ className, seller, routePathPattern }) => (
    <LineMenu className={cx(styles.SellerLineMenu, className)}>
        <Link
            className={cx(
                styles.SellerLineMenu__link,
                routePathPattern === bazaarSellerBazaarUrl &&
                    styles["SellerLineMenu__link--active"],
            )}
            to={url(bazaarSellerBazaarUrl, { username: seller.user.username })}
        >
            {BZ2_MENU_PRODUCTS}{" "}
            <span className={styles.SellerLineMenu__link__count}>({seller.productsCount})</span>
        </Link>
        <Link
            className={cx(
                styles.SellerLineMenu__link,
                (routePathPattern === bazaarSellerReviewsFromSellersUrl ||
                    routePathPattern === bazaarSellerReviewsFromBuyersUrl) &&
                    styles["SellerLineMenu__link--active"],
            )}
            to={url(bazaarSellerReviewsFromBuyersUrl, { username: seller.user.username })}
        >
            {BZ2_MENU_REVIEWS}{" "}
            <span className={styles.SellerLineMenu__link__count}>({seller.reviewsCount})</span>
        </Link>
    </LineMenu>
));

SellerLineMenu.displayName = "SellerLineMenu";

export default SellerLineMenu;
